import React, { useEffect, useState } from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import apiClient from '../../services/api';
import PoweredByCredit from '../common/PoweredByCredit';

const Maintenance = () => {
  const [isMaintenance, setIsMaintenance] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const resp = await apiClient.getMaintenanceStatus();
        if (mounted && resp && resp.success) {
          setIsMaintenance(Boolean(resp.data?.maintenance));
        }
      } catch (e) {
        // default true keeps page visible if server unreachable
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        padding: 2
      }}
    >
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <Box
          sx={{
            background: 'white',
            borderRadius: 4,
            padding: 6,
            boxShadow: '0px 10px 40px rgba(0, 0, 0, 0.1)',
            maxWidth: 600,
            mx: 'auto'
          }}
        >
          {/* Hospital Logo */}
          <Box sx={{ mb: 4 }}>
            <img 
              src="/hih-logo.png" 
              alt="Hearts International Hospital" 
              style={{ 
                height: '80px', 
                width: 'auto',
                maxWidth: '200px'
              }}
            />
          </Box>
          
          <Typography 
            variant="h2" 
            sx={{ 
              fontWeight: 800, 
              mb: 3,
              color: '#1976d2',
              fontSize: { xs: '2rem', sm: '3rem', md: '3.75rem' }
            }}
          >
            We'll be back soon
          </Typography>
          <Typography 
            variant="h6" 
            sx={{ 
              color: 'text.secondary', 
              mb: 5,
              lineHeight: 1.6,
              fontSize: { xs: '1rem', sm: '1.25rem' }
            }}
          >
            Our website is currently undergoing scheduled maintenance.
            <br />
            We appreciate your patience and apologize for any inconvenience.
          </Typography>
          {!isMaintenance && (
            <Button 
              component={RouterLink} 
              to="/" 
              variant="contained"
              size="large"
              sx={{
                px: 4,
                py: 1.5,
                fontSize: '1.1rem',
                fontWeight: 600
              }}
            >
              Go to Home
            </Button>
          )}
        </Box>
        <PoweredByCredit />
      </Container>
    </Box>
  );
};

export default Maintenance;




